enum GlobalFontSizes {
  Small = 13,
}

export default GlobalFontSizes
